import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8787";

export const emptySplitApi = createApi({
  reducerPath: "droneApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  tagTypes: ["Drones", "Telemetry", "Queue"],
  endpoints: () => ({}),
});
